export const DATA_HOOKS = {
  ERROR_TOOLTIP_ICON: 'counter-error-icon',
  ERROR_TOOLTIP_ICON_WRAPPER: 'counter-popover-element',
  PLUS_BUTTON: 'counter-plus-button',
  MINUS_BUTTON: 'counter-minus-button',
};

export const DATA_ATTRS = {
  DISABLED: 'data-disabled',
  ERROR: 'data-error',
  FOCUSED: 'data-focused',
};
